var map = {
	"./Home.vue": [
		8249
	],
	"./Login.vue": [
		2752
	],
	"./activity/ActivityPrize.vue": [
		7928,
		7928
	],
	"./agent/AgentArea.vue": [
		8927,
		8927
	],
	"./agent/AgentManage.vue": [
		7412,
		7412
	],
	"./agent/AgentOrder.vue": [
		2634,
		2634
	],
	"./agent/AgentRole.vue": [
		8605,
		8605
	],
	"./agent/AgentUser.vue": [
		1123,
		3504
	],
	"./api/ApiPhonePackage.vue": [
		6673,
		6673
	],
	"./api/ApiPointsDiscount.vue": [
		3155,
		3155
	],
	"./art/ArticleClassification.vue": [
		5103,
		5103
	],
	"./art/ArticleList.vue": [
		1338,
		1338
	],
	"./business/BusinessSettleIn.vue": [
		7985,
		7985
	],
	"./diy/diy.vue": [
		4200
	],
	"./finance/FinanceOrder.vue": [
		5231,
		5231
	],
	"./finance/FinanceOrderExcel.vue": [
		1287,
		1287
	],
	"./goods/GoodsClassification.vue": [
		3733,
		3733
	],
	"./log/LogAddUserBalance.vue": [
		2523,
		2523
	],
	"./log/LogStatisticsOilStation.vue": [
		1351,
		1351
	],
	"./log/LogUserBalance.vue": [
		352,
		352
	],
	"./log/LogUserPoints.vue": [
		180,
		180
	],
	"./mall/MallGoods.vue": [
		4121,
		4121
	],
	"./mall/MallGoodsCategory.vue": [
		4099,
		4099
	],
	"./mall/MallOrder.vue": [
		6042,
		6042
	],
	"./order/OrderList.vue": [
		1080,
		1080
	],
	"./order/OrderOil.vue": [
		2422,
		2422
	],
	"./order/OrderOilCard.vue": [
		8919,
		8919
	],
	"./order/OrderPetroChina.vue": [
		7646,
		254,
		7646
	],
	"./order/OrderProportion.vue": [
		6204,
		6204
	],
	"./order/OrderReplenish.vue": [
		4654,
		4654
	],
	"./order/OrderTelList.vue": [
		7390,
		7390
	],
	"./sys/SysArticle.vue": [
		3323,
		254,
		5338,
		1577
	],
	"./sys/SysCategorical.vue": [
		665,
		254,
		5338,
		4015
	],
	"./sys/SysPermission.vue": [
		194,
		194
	],
	"./sys/SysRole.vue": [
		764,
		254,
		5338,
		5548
	],
	"./sys/SysSetting.vue": [
		5939,
		5939
	],
	"./sys/SysUser.vue": [
		5902,
		254,
		5338,
		2822
	],
	"./sys/SyscreateArticle.vue": [
		2870,
		2870
	],
	"./test/TestEditor.vue": [
		152,
		152
	],
	"./test/TestOne.vue": [
		6533,
		6533
	],
	"./user/UserBankCardInformation.vue": [
		5005,
		5005
	],
	"./user/UserBindPetroChina.vue": [
		7434,
		7434
	],
	"./user/UserBindSinopec.vue": [
		5464,
		5464
	],
	"./user/UserCash.vue": [
		9479,
		9479
	],
	"./user/UserCashExamine.vue": [
		5213,
		5213
	],
	"./user/UserComplaint.vue": [
		4297,
		4297
	],
	"./user/UserDetail.vue": [
		8367,
		8367
	],
	"./user/UserInfo.vue": [
		1967,
		1967
	],
	"./user/UserList.vue": [
		2023,
		2023
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4235;
module.exports = webpackAsyncContext;